<template>
 <div class="app-container">
   <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true"  class="demo-form-inline" label-width="110px" size="mini">
        <div class="formItemBox">
         <el-form-item label="车辆号牌:">
          <el-input placeholder="" v-model="searchFrom.plateNumber" ></el-input>
        </el-form-item>
        <el-form-item label="司机姓名:">
          <el-input placeholder="" v-model="searchFrom.driverName" ></el-input>
        </el-form-item>
        <el-form-item label="维修时间:" class="item2"  >
          <el-date-picker
            v-model="searchFrom.repairStartTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :default-time="['00:00:00', '23:59:59']"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="维修单号:">
          <el-input placeholder="" v-model="searchFrom.businessNo" ></el-input>
        </el-form-item>
        <el-form-item label="维修商:">
          <el-select v-model="searchFrom.customerName" filterable  placeholder="请选择" >
            <el-option v-for="item in gysList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="审核状态:" >
          <el-select  v-model="searchFrom.auditStatus"  placeholder="请选择">
            <el-option label="全部" value="" ></el-option>
            <el-option label="待审核" value="待审核" ></el-option>
            <el-option label="审核通过" value="审核通过" ></el-option>
            <el-option label="审核驳回" value="审核驳回" ></el-option>
            <el-option label="不审核" value="不审核" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属小队:" >
          <el-select v-model="searchFrom.teamCode" filterable placeholder="请选择" clearable  >
            <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="维修类型:">
          <el-select v-model="searchFrom.repairType" filterable placeholder="请选择">
            <el-option v-for="item in repairData" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" v-if="btnFlg[0]" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchFrom')">重置</el-button>
            <el-button type="primary" v-if="btnFlg[1]" @click="exportFn" size="mini" :disabled="isDisable">导出</el-button>
            <el-button type="primary" v-if="btnFlg[2]" @click="addFn" size="mini" >新增</el-button>
            <el-button type="primary" v-if="btnFlg[3]" @click="delFn" size="mini" >删除</el-button>
            <el-button type="primary" @click="importFn" size="mini" >导入</el-button>
            <el-button type="primary" size="mini" @click="modelDown">模板下载</el-button>
          </div>
          <div class="tongjiBox">
             <el-form-item style="margin-left:8px">
                <p class="margin0" >
                  维修金额合计<span class="red">{{sum.totalAmount}}</span>元
                </p>
              </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{height:h}">
      <el-table :data="tableList" ref="table" v-loading="loading" bordersize="mini" @selection-change="selectGoods" @row-click="handleRowClick" style="width: 100%" height="100%"  center border class="tableComent">
       <el-table-column type="selection" width="55"></el-table-column>
       <el-table-column type="index" width="55" label="序号"></el-table-column>
       <el-table-column label="操作" width="160" >
          <template slot-scope="scope">
            <div>
              <el-button v-if="btnFlg[4]" type="text" size="mini"  @click="pingzhengFn(scope.row)">凭证</el-button>
              <el-button v-if="btnFlg[5]&&(scope.row.auditStatus=='待审核')&&scope.row.fillStatus=='2'" type="text" size="mini" @click="tongguoFn(scope.row)">通过</el-button>
              <el-button v-if="btnFlg[6]&&(scope.row.auditStatus=='待审核')&&scope.row.fillStatus=='2'" type="text" size="mini" @click="bohuiFn(scope.row)">驳回</el-button>
              <el-button v-if="btnFlg[7]&&(scope.row.auditStatus!='审核通过')" type="text" size="mini"  @click="editFn(scope.row)">修改</el-button>
            </div>
          </template>
        </el-table-column>
       <el-table-column :show-overflow-tooltip="true" prop="businessNo" label="维修单号" align="center"
             min-width="190"></el-table-column>
       <el-table-column property=""  width="80" label="审核状态" >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.auditStatus=='待审核'" style="color: #E6A23C;">{{scope.row.auditStatus}}</span>
              <span v-if="scope.row.auditStatus=='审核通过'" style="color: #67C23A">{{scope.row.auditStatus}}</span>
              <span v-if="scope.row.auditStatus=='审核驳回'" style="color: #F56C6C">{{scope.row.auditStatus}}</span>
              <span v-if="scope.row.auditStatus=='不审核'">{{scope.row.auditStatus}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column property="" width="80" label="状态" >
          <template slot-scope="scope">
            <div>
              <span v-if="scope.row.fillStatus=='1'" style="color: #E6A23C;">维修中</span>
              <span v-if="scope.row.fillStatus=='2'" style="color: #67C23A">已完成</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="customerName" label="维修商" align="center"
             min-width="150"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="repairType" label="维修类型" align="center"
          width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="maintenanceContent" label="维修项目" align="center"
          width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="materialName" label="材料名称" align="center"
          width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="materialCost" label="材料费" align="center"
          width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" label="工时费" prop="laborCost" align="center"
          width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="totalCost" label="维修金额(元)" align="center"
          width="110"></el-table-column>
        <el-table-column prop="repairStartTime" label="维修开始时间" :formatter="dateTimeFormat" width="170" ></el-table-column>
        <el-table-column prop="repairEndTime" label="维修结束时间" :formatter="dateTimeFormat" width="170"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="plateNumber" label="车号" min-width="90" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="trailerPlate" label="挂车牌号" min-width="90" :formatter="formatterRowEmpty"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverName" label="司机" align="center"
             min-width="80"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="driverPhone" label="司机电话" align="center"
             min-width="120"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="teamName" label="小队" align="center"
          min-width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="remark" label="申请备注" align="center"
          min-width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="auditReject" label="审核备注" align="center"
          min-width="100"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="source" label="来源" align="center" min-width="80">
          <template slot-scope="scope">
            <span >{{['司机上报','统计上传'][scope.row.source-1]}}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="createUser" label="创建人" align="center" min-width="80"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" :formatter="dateTimeFormat" width="170"></el-table-column>
        <el-table-column :show-overflow-tooltip="true" prop="auditName" label="审核人" align="center"
          min-width="100"></el-table-column>
        <el-table-column prop="auditDate" label="审核时间" :formatter="dateTimeFormat" width="170"></el-table-column>
      </el-table>
    </div>
     <!-- 分页 -->
    <div>
      <el-pagination background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchFrom.pageNo"
        :page-sizes="[50,100,200,500]"
        :page-size="searchFrom.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 添加 -->
    <el-dialog :title="isAdd?'添加':'修改'" :close-on-click-modal="false" :close-on-press-escape="false"  @close="closeDialog" :visible.sync="addFlag" width="750px" center>
      <div>
        <el-form :inline="true" :rules="rules" ref="addForm" :model="addForm" class="demo-form-inline jiaoyan"  label-width="110px" size="mini" v-if="addFlag">
          <el-form-item label="小队:" prop="teamCode" class="width1" >
            <el-select v-model="addForm.teamCode" filterable placeholder="请选择" clearable @change="xiaoduiChange" >
              <el-option v-for="item in XDList" :label="item.name" :value="item.code" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <br>
          <el-form-item label="司机姓名:" prop="driverId" class="width1" >
            <el-select  v-model="addForm.driverId" filterable placeholder="请选择" @change="sijiChange">
              <el-option v-for="item in sijiList" :label="item.name" :value="item.id" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
           <el-form-item label="司机手机号:" prop="driverPhone" class="width1" >
            <el-input  placeholder="" maxlength="50" v-model="addForm.driverPhone" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="车号:" prop="plateNumber" class="width1" >
            <el-select  v-model="addForm.plateNumber" filterable placeholder="请选择" @change="carChange">
              <el-option v-for="item in carList" :label="item.vhcNo" :value="item.vhcNo" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="挂车牌号:" prop="trailerPlate" class="width1" >
            <el-input placeholder="" maxlength="50" v-model="addForm.trailerPlate" :readonly="true"></el-input>
          </el-form-item>
          <el-form-item label="维修商:" prop="customerName" class="width1">
            <el-select  v-model="addForm.customerName" filterable  placeholder="请选择" @change="gysChange">
              <el-option v-for="item in gysList" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维修类型:" prop="repairType" class="width1">
            <el-select v-model="addForm.repairType" filterable  placeholder="请选择">
              <el-option v-for="item in repairData" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <br>
          <el-form-item label="维修项目:" prop="maintenanceContent" class="width2" >
            <el-input placeholder="" maxlength="100" v-model="addForm.maintenanceContent"  ></el-input>
          </el-form-item>
          <br>
          <el-form-item label="材料名称:" prop="materialName" >
            <el-input placeholder="" v-model="addForm.materialName"></el-input>
          </el-form-item>
          <el-form-item label="材料费:" prop="materialCost" class="jiage" v-if="!isNeiXiu">
            <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="addForm.materialCost"  ></el-input>
            <span class="danwei">元</span>
          </el-form-item>
          <el-form-item label="工时费:" prop="laborCost" class="jiage" >
            <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="addForm.laborCost"  ></el-input>
            <span class="danwei">元</span>
          </el-form-item>
          <el-form-item label="维修金额:" prop="totalCost" class="jiage" v-if="!isNeiXiu">
            <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="addForm.totalCost" :readonly="true"></el-input>
            <span class="danwei">元</span>
          </el-form-item>
          <el-form-item label="维修金额:" prop="totalCost" class="jiage" v-if="isNeiXiu">
            <el-input placeholder="" v-number-input.float="2" maxlength="8" v-model="addForm.totalCost"></el-input>
            <span class="danwei">元</span>
          </el-form-item>
          <br>
          <el-form-item label="维修开始时间" prop="repairStartTime" class="jiage" >
            <el-date-picker
              v-model="addForm.repairStartTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <el-form-item  label="维修结束时间" prop="repairEndTime" class="jiage" >
            <el-date-picker
              v-model="addForm.repairEndTime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="timestamp"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </el-form-item>
          <br>
          <el-form-item label="凭证:" class="remark is-required" prop="remark" v-if="addFlag" >
            <uploadImgs :imgList.sync='imgList' :max=3 @remove="remove"></uploadImgs>
          </el-form-item>
          <br>
          <el-form-item label="申请备注:" class="remark" prop="remark" >
            <el-input placeholder="" maxlength="500" v-model="addForm.remark"></el-input>
          </el-form-item>

        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addFlag = false">取 消</el-button>
        <el-button type="primary" @click="saveFn()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 凭证 -->
    <el-dialog  title="凭证" :close-on-click-modal="false" :close-on-press-escape="false"   :visible.sync="pzFlag" width="660px" center>
      <div class="fujianBox">
         <div class="imgBox">
            <el-image
              v-for="(item,index) in pzList" :src="item.fileKeyUrl" :key="index" :preview-src-list="getSrcList(index,pzList)">
            </el-image>
          </div>
      </div>
    </el-dialog>
    <!-- 驳回 -->
    <el-dialog title="驳回" :close-on-click-modal="false" :close-on-press-escape="false" @close="BHflag = false"  :visible.sync="BHflag" width="400px" center>
      <div>
        <el-form :inline="true" :rules="rules" ref="BHform" :model="BHform" class="demo-form-inline"  label-width="80px"  size="mini">
          <el-form-item label="驳回原因" class="item1" prop="auditReject">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="BHform.auditReject" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="BHflag = false">取 消</el-button>
        <el-button type="primary" @click="BHsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
     <!-- 审核 -->
    <el-dialog title="审核" :close-on-click-modal="false" :close-on-press-escape="false" @close="shFlag = false"  :visible.sync="shFlag" width="400px" center>
      <div>
        <el-form :inline="true" :rules="rules" ref="shForm" :model="shForm" class="demo-form-inline jiaoyan"  label-width="100px" size="mini" >
          <el-form-item label="审核状态:" prop="auditStatus">
            <template >
              <el-radio-group v-model="shForm.auditStatus"  >
                <el-radio label="1" >通过</el-radio>
                <el-radio label="2">驳回</el-radio>
              </el-radio-group>
            </template>
          </el-form-item>
          <el-form-item label="驳回原因:" class="item1" prop="auditReject" v-if="shForm.auditStatus==2">
            <el-input placeholder="" type="textarea" maxlength="100" v-model="shForm.auditReject" class="gjh"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="shFlag = false">取 消</el-button>
        <el-button type="primary" @click="SHsaveFn()">确 定</el-button>
      </span>
    </el-dialog>
     <el-image-viewer v-if="dialogImg" :on-close="closeViewer" :url-list="lookimgList" />
        <!-- 导入 -->
    <importC v-if="importDialog" @DRsave="DRsave" @destroy="destroy"></importC>
 </div>
</template>

<script>
import { getBtn } from '@/utils/getButton'
import { formatterRowEmpty, dateTimeFormat, dateFormat, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
import { costRecordList, saveOrUpdateCostWithAttachments, deleteCostRecord, getOilCostDetail, auditCostRecord,
  getDictionaryDetailList, costRecordImport } from '@/api/newTMS'
import { organizationTree, cDlists, cVIlists } from '@/api/vgs-driver2.0'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
import importC from '@/components/import.vue'
export default {
  components: {
    uploadImgs, ElImageViewer, importC
  },
  data () {
    return {
      h: 500,
      dateTimeFormat: dateTimeFormat,
      dateFormat: dateFormat,
      formatterRowEmpty: formatterRowEmpty,
      tableList: [],
      searchFrom: {
        pageNo: 1,
        pageSize: 50
      },
      total: 0,
      loading: false,
      isDisable: false,
      sum: {},
      rules: {
        teamCode: [
          { required: true, message: '请选择小队', trigger: 'blur' }
        ],
        driverId: [
          { required: true, message: '请选择司机', trigger: 'blur' }
        ],
        plateNumber: [
          { required: true, message: '请选择车辆', trigger: 'blur' }
        ],
        customerName: [
          { required: true, message: '请选择供应商', trigger: 'blur' }
        ],
        energyType: [
          { required: true, message: '请选择能源类型', trigger: 'blur' }
        ],
        totalCost: [
          { required: true, message: '请输入支付金额', trigger: 'blur' }
        ],
        auditReject: [
          { required: true, message: '请输入驳回原因', trigger: 'blur' }
        ],
        auditStatus: [
          { required: true, message: '请选择审核状态', trigger: 'blur' }
        ],
        repairStartTime: [
          { required: true, message: '请选择维修开始时间', trigger: 'blur' }
        ],
        repairEndTime: [
          { required: true, message: '请选择维修结束时间', trigger: 'blur' }
        ],
        maintenanceContent: [
          { required: true, message: '请输入维修项目', trigger: 'blur' }
        ],
        repairType: [
          { required: true, message: '请选择维修类型', trigger: 'blur' }
        ],
        materialName: [
          { required: true, message: '请输入材料名称', trigger: 'blur' }
        ],
        materialCost: [
          { required: true, message: '请输入材料费', trigger: 'blur' }
        ],
        laborCost: [
          { required: true, message: '请输入工时费', trigger: 'blur' }
        ]
      },
      isAdd: false,
      addFlag: false,
      addForm: { deleteAttachmentIds: [] },
      imgList: [],
      gysList: [], // 维修商
      XDList: [],
      sijiList: [],
      carList: [],
      pzList: [],
      pzFlag: false,
      BHflag: false,
      BHform: {},
      shForm: {},
      shFlag: false,
      yixuanData: {},
      dialogImg: false,
      lookimgList: [],
      importDialog: false,
      btnFlg: [],
      btnIdArr: ['01N01N0100', '01N01N0200', '01N01N0300', '01N01N0400', '01N01N0500', '01N01N0600', '01N01N0700', '01N01N0800'],
      repairData: [],
      laborHour: '',
      dictionaryName: '',
      isNeiXiu: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr)
    this.searchFn()
    getDictionaryDetailList({ dictionaryType: 'maintenance_fee_purchaser' }).then(res => { this.gysList = res })
    getDictionaryDetailList({ dictionaryType: 'repair_type' }).then(res => { this.repairData = res })
    getDictionaryDetailList({ dictionaryType: 'labor_hour_rate' }).then(res => { this.laborHour = res[0].showName })
    getDictionaryDetailList({ dictionaryType: 'repair_internal_company' }).then(res => { this.dictionaryName = res[0].showName })
    organizationTree({ flag: 1 }).then((res) => {
      if (res[0].orgType == 1) {
        this.XDList = res[0].children
      } else {
        this.XDList = res
      }
    })
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = (pH - h - 166) + 'px'
  },
  methods: {
    // 导入
    importFn () {
      this.importDialog = true
    },
    // 导入模板下载
    modelDown () {
      var tempwindow = window.open('_blank') // 先打开页面
      tempwindow.location = 'https://public-zw56.oss-cn-zhangjiakou.aliyuncs.com/tms/excel/维修保养导入模板.xlsx'// 后更改页面地址
    },
    DRsave (formData) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      // formData.append('params', JSON.stringify({ businessType: 6 }))
      formData.append('businessType', 3)
      costRecordImport(formData).then(res => {
        loading.close()
        this.importDialog = false
        var that = this
        this.msg = this.$message({
          showClose: true,
          message: res.message,
          duration: 3000,
          type: 'success',
          onClose () {

          }
        })
        this.getList(this.searchFrom)
      }).catch(err => {
        if (err.code == -1) {
          this.$message({
            type: 'warning',
            message: err.data ? err.data : err.message,
            onClose () {
              loading.close()
            }
          })
          this.isDisable = false
        } else if (err.code == 1) {
          this.isDisable = false
          this.$confirm('存在异常信息，是否确认导出异常信息?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            const loading = this.$loading({
              lock: true,
              text: '正在导出异常信息...'
            })
            let form = { businessType: 3 }
            exportExcel(
              this.global.tmsPlus +
                    '/costRecord/exportError',
              form,
              '异常信息表'
            )
            setTimeout(() => {
              this.$message({
                type: 'success',
                message: err.data ? err.data : err.message
              })
              loading.close()
              this.daoRuMark = false
              this.importDialog = false
              this.getList(this.searchFrom)
            }, 3000)
          }).catch(() => {
            this.daoRuMark = false
            this.$message({
              type: 'warning',
              message: '已取消异常信息导出，' + err.data ? err.data : err.message,
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          loading.close()
        }
      })
    },
    destroy () {
      this.importDialog = false
    },
    // 选择数据
    selectGoods (selection) {
      if (selection.length > 0) {
        this.$forceUpdate()
      } else {
        this.yixuanData = {}
      }
    },

    bohuiFn (row) {
      this.BHflag = true
      this.BHform = {}
      this.BHform.id = row.id
      this.BHform.auditStatus = 2
    },
    BHsaveFn () {
      this.$refs.BHform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          auditCostRecord(this.BHform).then(res => {
            loading.close()
            this.BHflag = false
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    tongguoFn (row) {
      this.$confirm('是否审核通过?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        auditCostRecord({
          id: row.id,
          auditStatus: 1
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 凭证
    pingzhengFn (row) {
      getOilCostDetail({ costId: row.id }).then(res => {
        if (res.attachments.length == 0) {
          this.$alert('暂无可查看的凭证', '系统提示')
        } else {
          this.lookimgList = []
          res.attachments.forEach((item, index) => {
            this.$set(this.lookimgList, index, item.fileKeyUrl)
          })

          this.dialogImg = true
        }
      })
    },
    closeViewer () {
      this.dialogImg = false
    },
    // 点击凭证放大
    getSrcList (index, arr) {
      let imgArr = arr.slice(index).concat(arr.slice(0, index))
      let urls = []
      imgArr.forEach(item => {
        urls.push(item.fileKeyUrl)
      })
      return urls
    },
    sijiChange (e) {
      if (e) {
        let json = this.sijiList.filter(item => item.id == e)
        this.$set(this.addForm, 'driverName', json[0].name)
        this.$set(this.addForm, 'driverPhone', json[0].mobile)
        this.$set(this.addForm, 'idNumber', json[0].identityNo)
      }
    },
    carChange (e) {
      if (e) {
        let json = this.carList.filter(item => item.vhcNo == e)
        this.$set(this.addForm, 'vehicleId', json[0].id)
        this.$set(this.addForm, 'licensePlateColorName', json[0].noColourName)
        this.$set(this.addForm, 'vehicleTypeName', json[0].energyName)
        this.$set(this.addForm, 'trailerPlate', json[0].trailerNo)
      }
    },
    xiaoduiChange (e) {
      if (e) {
        let json = this.XDList.filter(item => item.code == e)
        this.$set(this.addForm, 'teamName', json[0].name)
        this.$set(this.addForm, 'teamId', json[0].id)
        cDlists({ driverClassify: 2, teamOrgId: json[0].id }).then(res => {
          this.sijiList = res
        })
        cVIlists({ vhcClassify: 2, trailerFlag: 0, teamOrgId: json[0].id }).then(res => {
          this.loading = false
          this.carList = res
        })
        this.$set(this.addForm, 'driverId', null)
        this.$set(this.addForm, 'driverName', null)
        this.$set(this.addForm, 'driverPhone', null)
        this.$set(this.addForm, 'idNumber', null)
        this.$set(this.addForm, 'vehicleId', null)
        this.$set(this.addForm, 'plateNumber', null)
        this.$set(this.addForm, 'licensePlateColorName', null)
        this.$set(this.addForm, 'vehicleTypeName', null)
      }
    },
    // 添加
    addFn () {
      this.isAdd = true
      this.addFlag = true
      this.imgList = []
      this.$set(this.addForm, 'fillTime', new Date().getTime())
    },
    // 修改
    editFn  (row) {
      this.addForm = { ...row }
      this.addForm.deleteAttachmentIds = []
      this.imgList = []
      cDlists({ driverClassify: 2, teamOrgId: row.teamOrgId }).then(res => {
        this.sijiList = res
      })
      cVIlists({ vhcClassify: 2, trailerFlag: 0, teamOrgId: row.teamOrgId }).then(res => {
        this.loading = false
        this.carList = res
      })
      getOilCostDetail({ costId: row.id }).then(res => {
        this.isAdd = false
        this.addFlag = true
        res.attachments.forEach(item => {
          this.imgList.push({ status: 'ready', url: item.fileKeyUrl, id: item.id })
        })
      })
    },
    saveFn () {
      if (this.imgList.length == 0) {
        this.$alert('请上传凭证', '系统提示')
        return
      }
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let imgfile = new FormData()
          this.imgList.forEach(item => {
            if (!item.id) {
              imgfile.append('files', item.raw)
            }
          })
          if (this.isAdd) {
            this.addForm.source = 2
            this.addForm.businessType = 3
          }

          imgfile.set('params', JSON.stringify(this.addForm))
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          saveOrUpdateCostWithAttachments(imgfile).then(res => {
            loading.close()
            this.$message({
              message: '操作成功',
              type: 'success'
            })
            this.addFlag = false
            this.getList(this.searchFrom)
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        } else {
          return false
        }
      })
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.addForm.deleteAttachmentIds.push(file.id)
      }
    },
    // 供应商修改
    gysChange (e) {
      if (e) {
        let json = this.gysList.filter(item => item.showName == e)
        if (this.dictionaryName == e) {
          this.isNeiXiu = true
          this.$set(this.addForm, 'totalCost', '')
        } else {
          this.isNeiXiu = false
        }
        this.$set(this.addForm, 'customerId', json[0].itemNo)
      }
    },
    // 删除
    delFn () {
      let selectData = this.$refs.table.selection
      this.rowDataList = selectData
      if (selectData.length != 1) {
        this.$alert('请选择一条要操作的数据', '系统提示')
        return
      }
      if (selectData[0].source == 1) {
        this.$alert('司机上报不可删除', '系统提示')
        return
      }
      this.$confirm('是否执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: '正在处理...'
        })
        deleteCostRecord({
          ids: [selectData[0].id]
        }).then(res => {
          loading.close()
          this.getList(this.searchFrom)
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }).catch(() => {

      })
    },
    // 导出
    exportFn () {
      this.searchFrom.businessType = 3
      let form = { ...this.searchFrom }
      delete form.pageNo
      delete form.pageSize
      exportExcel(
        this.global.tmsPlus + '/costRecord/export',
        form,
        '维修列表'
      )
      this.isDisable = true
      setTimeout(() => {
        this.isDisable = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    },
    // 查选
    searchFn () {
      this.getList(this.searchFrom)
    },
    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 获取列表
    getList () {
      this.loading = true
      this.searchFrom.businessType = 3
      costRecordList(this.searchFrom).then(res => {
        this.tableList = res.list
        this.total = res.total
        this.sum = res.map
        this.loading = false
      })
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchFrom.pageSize = val
      this.getList(this.searchFrom)
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchFrom.pageNo = val
      this.getList(this.searchFrom)
    },
    // 重置
    resetForm (formName) {
      // debugger
      this.searchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.searchFn()
    },
    closeDialog () {
      this.addForm = {
        deleteAttachmentIds: []
      }
      this.imgLis = []
    }
  },
  watch: {
    addForm: {
      handler (newName, oldName) {
        if (this.isNeiXiu) {
        // 确保 laborHour 是数字类型
          // const laborHourValue = Number(this.laborHour) || 0
          // const laborHours = Number(this.addForm.laborHours) || 0
          // const materialCost = Number(this.addForm.materialCost) || 0

          // if (this.addForm.laborHours && this.addForm.materialCost) {
          // // 如果是内修：维修金额 = (工时 * 工时费) + 材料费
          //   const total = (laborHours * laborHourValue) + materialCost
          //   this.$set(this.addForm, 'totalCost', toFixed(total, 2))
          // }
        } else {
          // 外修  外部供应商:材料费+工时费
          const materialCost = Number(this.addForm.materialCost) || 0
          const laborCost = Number(this.addForm.laborCost) || 0
          const total = materialCost + laborCost
          this.$set(this.addForm, 'totalCost', toFixed(total, 2))
        }
      },
      immediate: true,
      deep: true
    }
  }

}
</script>

<style scoped lang='less'>
.searchBtnBox{
  margin: 10px 0;
}
/deep/.el-form{
  width: 100%;
}
.jiaoyan /deep/.el-input__inner{
      width: 180px;
}
.imgBox{
  margin:0;
}

.inpBox .dzBox  /deep/.el-input__inner {
    width: 170px;
}
.imgBox{
  /deep/.el-image{
    width: 180px;
    height: 130px;
    margin-right: 20px;
  }
}
.remark  /deep/.el-input .el-input__inner {
    width: 480px;
    height: 80px;
}
.tongjiBox{
   /deep/.el-form-item--mini .el-form-item__content,  /deep/.el-form-item--mini .el-form-item__label{
        line-height: 20px;
  }
}
.width2  /deep/.el-input .el-input__inner {
    width: 480px;
}
.formItemBox{
  /deep/.el-form-item{
    width: 24%;
  }
}
</style>
